import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import NotLogged from 'components/NotLogged'
import IncidentForm from 'views/IncidentsSelfService/IncidentForm'

function YourIncidents() {
  const { t } = useTranslation()
  const { auth = {} } = useSelector((store) => store)

  if (!auth.isAuthenticated) {
    return (
      <section>
        <NotLogged />
      </section>
    )
  }

  return (
    <IncidentForm
      title={t('yourIncidents.label.create')}
      description={t('yourIncidents.label.description')}
    />
  )
}

export default YourIncidents
